import "core-js/modules/es.object.get-prototype-of.js";
import "core-js/modules/es.reflect.construct.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
var _excluded = ["className", "text", "type", "onDismiss", "expireAfter", "dismissable", "icon", "iconSize", "dismissIcon", "center", "actions", "banner", "toast", "bannerMuted", "containedByGrid", "children", "dismissButtonAriaLabel", "dismissButtonRef", "role"];
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.number.constructor.js";
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
/*
 * Licensed Materials - Property of IBM
 *
 * PID 5725-H26
 *
 * Copyright IBM Corporation 2017,2020. All Rights Reserved.
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */

import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import invoke from 'lodash.invoke';
import Button from './Button';
import Icon from './Icon';
import IconSet from './IconSet';

/**
 * Represents an Alert displayed to the user
 */

var propTypes = {
  /**
   additional class name
  */
  className: PropTypes.string,
  /**
   text to display on the alert
  */
  text: PropTypes.node,
  /**
   specifies type of alert. Can be one of 'success', 'warning', 'danger', 'info' and 'banner'
  */
  type: PropTypes.oneOf(['success', 'warning', 'danger', 'info']),
  /**
    onCloseClick props for close button
  */
  onDismiss: PropTypes.func,
  /**
   specifies if the alert should contain a close button
  */
  dismissable: PropTypes.bool,
  /**
   children of Alert component
  */
  children: PropTypes.node,
  /**
    Specifies a icon for the alert. Accepts either a string that references a
    icon from the sprite sheet,
    or a Icon/IconSet component with the "wds-c-alert__icon" styling class.
  */
  icon: PropTypes.oneOfType([PropTypes.shape({
    type: PropTypes.oneOf([Icon])
  }), PropTypes.shape({
    type: PropTypes.oneOf([IconSet])
  }), PropTypes.string]),
  /** size of icon */
  iconSize: PropTypes.oneOf(['medium', 'small']),
  /**
   icon component as dismiss icon
  */
  dismissIcon: PropTypes.oneOfType([PropTypes.shape({
    type: PropTypes.oneOf([Icon])
  }), PropTypes.shape({
    type: PropTypes.oneOf([IconSet])
  }), PropTypes.string]),
  /** center alignment of content */
  center: PropTypes.bool,
  /** actions buttons inside the alert */
  actions: PropTypes.arrayOf(PropTypes.node),
  /** specifies if the Alert is a banner, banner style can work together with all Alert types */
  banner: PropTypes.bool,
  /** specifies if the Alert is muted */
  bannerMuted: PropTypes.bool,
  /** specifies if the Alert is contained by grid */
  containedByGrid: PropTypes.bool,
  /** specifies if the alert is a "toast" notification type alert */
  toast: PropTypes.bool,
  /** auto expire in seconds for toast alerts.
   * Set this to the number of seconds you wish the alert should expire after
   */
  expireAfter: PropTypes.number,
  /** Aria label for the dimiss button */
  dismissButtonAriaLabel: PropTypes.string,
  /** dismiss button reference */
  dismissButtonRef: PropTypes.elementType,
  /**
   * Defaults to either "status" or "alert" for Toast alerts, depending on alert type.
   * Undefined for all other alert variants. Use "alertdialog" for interactive alerts.
   */
  role: PropTypes.string
};
var defaultProps = {
  className: undefined,
  text: undefined,
  type: 'info',
  onDismiss: function onDismiss() {},
  children: undefined,
  dismissable: true,
  icon: undefined,
  iconSize: 'small',
  dismissIcon: undefined,
  center: false,
  actions: undefined,
  banner: false,
  toast: false,
  bannerMuted: false,
  containedByGrid: false,
  expireAfter: undefined,
  dismissButtonAriaLabel: 'Dismiss',
  dismissButtonRef: undefined,
  role: undefined
};
export var ALERT_MIN_WIDTH_ACTIONS_LAYOUT_ROW = 840;
var Alert = /*#__PURE__*/function (_React$Component) {
  _inherits(Alert, _React$Component);
  var _super = _createSuper(Alert);
  function Alert(props) {
    var _this;
    _classCallCheck(this, Alert);
    _this = _super.call(this, props);
    _defineProperty(_assertThisInitialized(_this), "handleDismiss", function () {
      if (_this.props.toast) {
        _this.setTransitionTimer(true);
      } else {
        _this.props.onDismiss(_assertThisInitialized(_this));
      }
    });
    _this.state = {
      toastHidden: true
    };
    _this.toastExpireTimer = null;
    _this.transitionTimer = null;
    _this.ref = /*#__PURE__*/React.createRef();
    return _this;
  }
  _createClass(Alert, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.toast) {
        this.setTransitionTimer();
        if (this.props.expireAfter) {
          this.setToastExpirationTimer();
        }
      }
      invoke(window.govhhswds, ['eqjs', 'query'], document.body);
      if (this.ref.current.offsetWidth >= ALERT_MIN_WIDTH_ACTIONS_LAYOUT_ROW) {
        this.ref.current.setAttribute('eq-state', 'small');
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.clearTimers();
    }
  }, {
    key: "setTransitionTimer",
    value: function setTransitionTimer(dimissAlert) {
      var _this2 = this;
      this.transitionTimer = setTimeout(function () {
        _this2.setState(function (prevState) {
          return {
            toastHidden: !prevState.toastHidden
          };
        });
        if (dimissAlert) {
          setTimeout(function () {
            return _this2.props.onDismiss(_this2);
          }, 200);
          _this2.clearTimers();
        }
      }, 100);
    }
  }, {
    key: "setToastExpirationTimer",
    value: function setToastExpirationTimer() {
      var _this3 = this;
      this.toastExpireTimer = setTimeout(function () {
        _this3.handleDismiss();
      }, this.props.expireAfter * 1000);
    }
  }, {
    key: "clearTimers",
    value: function clearTimers() {
      clearTimeout(this.toastExpireTimer);
      clearTimeout(this.transitionTimer);
    }
  }, {
    key: "render",
    value: function render() {
      var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
      var className = _ref.className,
        text = _ref.text,
        type = _ref.type,
        onDismiss = _ref.onDismiss,
        expireAfter = _ref.expireAfter,
        dismissable = _ref.dismissable,
        icon = _ref.icon,
        iconSize = _ref.iconSize,
        dismissIcon = _ref.dismissIcon,
        center = _ref.center,
        actions = _ref.actions,
        banner = _ref.banner,
        toast = _ref.toast,
        bannerMuted = _ref.bannerMuted,
        containedByGrid = _ref.containedByGrid,
        children = _ref.children,
        dismissButtonAriaLabel = _ref.dismissButtonAriaLabel,
        dismissButtonRef = _ref.dismissButtonRef,
        role = _ref.role,
        otherProps = _objectWithoutProperties(_ref, _excluded);
      var dismissIconElement = dismissIcon || /*#__PURE__*/React.createElement(IconSet, {
        decorative: true,
        name: "close"
      });
      var styleClass = classnames("wds-c-alert wds-c-alert--".concat(type), {
        'wds-c-alert--banner-muted': bannerMuted
      }, {
        'wds-c-alert--banner': banner
      }, {
        'wds-c-alert--toast': toast
      }, {
        'wds-is-hidden': toast && this.state.toastHidden
      });
      var dismissButton = /*#__PURE__*/React.createElement(Button, {
        ref: dismissButtonRef,
        className: "wds-c-button--icon wds-c-alert__close",
        onClick: this.handleDismiss,
        "aria-label": dismissButtonAriaLabel
      }, dismissIconElement);
      var alertIcon = typeof icon === 'string' ? /*#__PURE__*/React.createElement(IconSet, {
        className: "wds-c-alert__icon",
        name: icon,
        size: iconSize,
        decorative: true
      }) : icon;
      var defaultRole;
      switch (type) {
        case 'success':
          {
            defaultRole = 'status';
            break;
          }
        case 'warning':
          {
            defaultRole = 'alert';
            break;
          }
        case 'danger':
          {
            defaultRole = 'alert';
            break;
          }
        case 'info':
        default:
          {
            defaultRole = 'status';
            break;
          }
      }
      var alertRole = toast ? role || defaultRole : role;
      var alertBodyContent = /*#__PURE__*/React.createElement(React.Fragment, null, children, text && /*#__PURE__*/React.createElement("div", {
        className: "wds-c-alert__text"
      }, text));
      var alertBody = /*#__PURE__*/React.createElement("div", {
        className: "wds-c-alert__wrapper"
      }, /*#__PURE__*/React.createElement("div", _extends({
        className: "wds-c-alert__body"
      }, alertRole && {
        role: alertRole
      }), actions ? /*#__PURE__*/React.createElement("div", {
        className: "wds-c-alert__container"
      }, alertBodyContent) : alertBodyContent), actions && /*#__PURE__*/React.createElement("div", {
        className: "wds-c-alert__actions"
      }, /*#__PURE__*/React.createElement("div", null, actions)));
      var alertStyle = classnames(className, styleClass, {
        'wds-c-alert--center': center
      });
      return /*#__PURE__*/React.createElement("div", _extends({
        ref: this.ref,
        className: alertStyle
      }, actions && {
        'data-eq-pts': "small: ".concat(ALERT_MIN_WIDTH_ACTIONS_LAYOUT_ROW)
      }, otherProps), !containedByGrid && icon && alertIcon, containedByGrid && /*#__PURE__*/React.createElement("div", {
        className: "wds-l-grid"
      }, /*#__PURE__*/React.createElement("span", {
        className: "wds-c-alert__icon-container"
      }, icon && alertIcon), alertBody, dismissable && dismissButton), !containedByGrid && alertBody, !containedByGrid && dismissable && dismissButton);
    }
  }]);
  return Alert;
}(React.Component);
Alert.propTypes = propTypes;
Alert.defaultProps = defaultProps;
export default Alert;